import { css } from 'twind/css'

export const fakeInputGroup = css({
  border: '1px solid var(--gray-5)',
})

export const fakeInput = css({
  color: 'var(--gray-6)',
})

export const fakeSendButton = css({
  background: 'var(--gray-4)',
  padding: '10px',
})
